import { Pipe, PipeTransform } from '@angular/core';
import { Plan } from '../types/plan';

/**
 * The name merchants see for a plan: its display name, or its admin `name` when none is set. Older
 * plan snapshots have no display name and show the name the merchant subscribed under. The
 * backend's `planDisplayName` follows the same rule for the Shopify charge.
 */
export const planDisplayName = (plan: Pick<Plan, 'name' | 'displayName'> | null | undefined) =>
  plan?.displayName?.trim() || plan?.name || '';

/** `planDisplayName` for templates. Logic that keys off a plan ('Free', 'Enterprise') keeps `name`. */
@Pipe({
  name: 'planDisplayName',
  standalone: true,
})
export class PlanDisplayNamePipe implements PipeTransform {
  transform(plan: Pick<Plan, 'name' | 'displayName'> | null | undefined): string {
    return planDisplayName(plan);
  }
}
